import * as angular from "angular";
import * as _ from "lodash";
import {IWindowService} from "angular";
import {AnalyticsService} from "../../commons/services/analytics-service.service";
import {resolveTenantId, TENANT_HEADER} from "../../commons/utils/tenant.util";

angular
  .module('bringoz.admin.authentication')
  .factory('AuthInterceptor', AuthInterceptor);

/* @ngInject */
function AuthInterceptor($q, $injector, $window: IWindowService, analyticsService: AnalyticsService) {

  return {
    request: request,
    responseError: responseError
  }

  function request(config) {
    const tenant = resolveTenantId($window as unknown as Window);
    const adminToken: string = localStorage.getItem('admin_token') || localStorage.getItem('access_token');

    if (!!tenant) {
      config.headers[TENANT_HEADER] = tenant;
      // config.headers['Accept'] = 'application/json;odata=verbose';
    }
    if (adminToken) {
      const isConfigurationClient = config.url.endsWith('iam/sso/configuration');
      config.headers['Authorization'] = !isConfigurationClient ? `Bearer ${adminToken}` : undefined;
    }
    return config;
  }

  function responseError(rejection) {

    // this.Heap.track('Error');
    analyticsService.trackException(rejection);

    if (rejection.status === 401) {
      if (!_.get($injector, 'config.url', '').endsWith(`/iam/authenticate`)) {
        $injector.invoke(['$state', ($state) => {
          if ($state.current.name !== 'authentication.login') {
            $state.go('authentication.login');
          }
        }]);
      }
    }

    if (rejection.status === 403) {
      $injector.invoke(['$state', ($state) => {
        $state.go('403');
      }]);
    }

    // All other errors handled at app.run.js

    // if (rejection.status === 500) {
    //   $injector.invoke(['$state',($state) => {
    //     $state.go('500');
    //   }]);
    // }

    return $q.reject(rejection);
  }
}
